import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPUser } from './dp-user';
import { DPUserService } from './dp-user.service';
import { DPRole } from './dp-role';
import { DPAccount } from './dp-account';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import {DPAccountService} from './dp-accounts.service';

@Component({
  selector: 'my-user-detail',
  templateUrl: 'dp-user-detail.component.html',
})
export class DPUserDetailComponent implements OnInit {
  @Input() user: DPUser;
  @Output() close = new EventEmitter();
  error: any;
  navigated = false; // true if navigated here
  errorResponse: any;
  success: any;
  accounts= [];
  all_acoounts = [];

  roles: DPRole[];
  storedRoles: string[];
  storedStatus: number;
  isFirst: any;
  isStatusFirst: any;
  foundIt: any;
  notificationTitle: any;
  notificationContent: any;
  notificationType: any;
  submitting = false;
  jobTitle = 'Not Identified';
  account_information = 'Not Identified';
  department = 'Not Identified';
  private new_account: any;
  private isNewAccount = false;


  constructor(
    private toasterService: ToasterService,

    private _service: NotificationsService,
    private router: Router,
    private userService: DPUserService,
    private accountService: DPAccountService,
    private route: ActivatedRoute) {
  }

  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };


  createNotification() {
    this.toasterService.pop(this.notificationType, this.notificationTitle, this.notificationContent);
  }

  errorHandler(error: any) {
    this.submitting = false;
    this.notificationType = 'error';
    this.notificationTitle = 'Error';
    const jsonErrorBody = JSON.parse(error._body);
    this.notificationContent = jsonErrorBody.error.message;
    this.createNotification();
  }


   async ngOnInit() {
     this.getRoles();
     await this.getAllAccounts();
     this.new_account = undefined;
     this.isNewAccount = false;

     for (let account of this.accounts) {
       this.all_acoounts.push(account.account_id + ' - ' + account.account_name);
     }

     console.log(this.all_acoounts);

     this.route.params.forEach((params: Params) => {
       const userId = +params['userId'];
       this.navigated = true;
       this.userService.getUser(userId)
           .then(user => {
             this.user = user;
             this.department = this.user.department == undefined || this.user.department == '' ? 'Not Identified' : this.user.department;
             this.jobTitle = this.user.title == undefined || this.user.title == '' ? 'Not Identified' : this.user.title;
             this.account_information = this.user.account.account_name === undefined || this.user.account.account_name === '' ? 'Not Identified' : this.user.account.account_id + ' - ' + this.user.account.account_name;
             console.log(this.account_information)
           });
     });

     this.storedRoles = [''];
     this.isFirst = true;
     this.isStatusFirst = true;
     this.storedStatus = 0;


   }

  getRoles() {
    return this.userService
      .getRoles()
      .then(res => {

        this.roles = res.user_roles;
        this.roles = this.roles.filter(r => r.role_name != 'Portal Viewer');

      })
      .catch(error => this.errorHandler(error));
  }

  mapAccountResultItem(item) {
    // console.log(item);
    return {
      account_id: item.account_id,
      account_name: item.account_name
    };
  }

  async getAllAccounts() {
    return this.accountService
        .getAllAccounts()
        .then(res => {

          this.accounts = this.accounts.concat(res.user_accounts.map(item => this.mapAccountResultItem(item)));


        })
        .catch(error => this.errorHandler(error));
  }


  save1(user: DPUser, isValid: boolean) {
    // call API to save customer

    // const accountInformation = (user.account_information).split('-', 1);
    // const accountId = accountInformation[0].replace(/\s/g, '');

    // tslint:disable-next-line:radix
    // user.id_account = parseInt(accountId);

    if (isValid === true) {
      this.submitting = true;
      //check role has been changed
      if (this.isFirst === false) {
        user.roles = this.storedRoles;
      } else {
        user.roles = this.user.roles;
      }
      //check status has been changed
      if (this.isStatusFirst === false) {
        user.status = this.storedStatus;
      } else {
        user.status = this.user.status;
      }
      user.title = this.jobTitle === 'Not Identified' ? '' : this.jobTitle;
      user.department = this.department === 'Not Identified' ? '' : this.department;
      if(this.isNewAccount){
       user.account = this.new_account;
      }else {
        user.account = this.user.account;
      }
      user.confirmPassword = undefined;
      user.email_sent = undefined;



      user.modules = undefined;
      user.notifications = undefined;
      user.settings = undefined;


      user.created_on = undefined;
      if (user.new_password === '') {
        user.new_password = undefined;
      }


      //perform save
      this.save(user);
    }
  }

  save(user: DPUser) {
    this.userService
      .updateUser(user)
      .then(user => {
        this.user = user; // saved hero, w/ id if new
        this.goBack();
      })
      .catch(error => this.errorHandler(error));
  }
  goBack() {
    if (this.navigated) {
      event.stopPropagation();
      this.router.navigate(['/demandportal/customer/account/users', this.user.account.account_id]);
    }
  }
  public activeStatus = [
    { value: 0, display: 'Inactive' },
    { value: 1, display: 'Active' },
  ];

  checkRole(role: DPRole) {
    this.foundIt = false;
    if (this.isFirst == true) {
      this.storedRoles.splice(0, 1);
      for (const item of this.user.roles) {
        this.storedRoles.push(item);
      }
      this.isFirst = false;
      for (const item of this.storedRoles) {
        if (item == role.role_name) {
          this.storedRoles.splice(this.storedRoles.indexOf(item), 1);
          this.foundIt = true;
        }
      }
      if (this.foundIt == false) {
        this.storedRoles.push(role.role_name);
      }
    }
    else {
      for (const item of this.storedRoles) {
        if (item == role.role_name) {
          this.storedRoles.splice(this.storedRoles.indexOf(item), 1);
          this.foundIt = true;
        }
      }
      if (this.foundIt == false) {
        this.storedRoles.push(role.role_name);
      }
    }

  }

  checkExistingRole(role: DPRole) {
    for (const item of this.user.roles) {
      if (item == role.role_name) {
        return true;
      }
    }
    return false;
  }

  checkExistingStatus() {
    if (this.user.status == 1) {
      return true;
    }
    return false;
  }

  checkStatus() {
    if (this.isFirst == true) {
      this.storedStatus = this.user.status;
      this.isStatusFirst = false;
    }

    if (this.storedStatus == 0) {
      this.storedStatus = 1;
    }
    else {
      this.storedStatus = 0;
    }
  }

  async updateAccountInformation(value: any) {
    const accountInformation = (value).split('-', 1);
    const accountId = accountInformation[0].replace(/\s/g, '');

    this.isNewAccount = true;

    const newAccountInformation = await this.accountService.getAccount(accountId)
        .then(account => {
          this.new_account = account;
        });

  }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-user-detail.component.ts